export function LinkShare1Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M6.343 17.657a3 3 0 010-4.243l2.121-2.121A1 1 0 007.05 9.879L4.93 12a5 5 0 006.607 7.482 6 6 0 107.946-7.946A5.001 5.001 0 0012 4.929L9.879 7.05a1 1 0 101.414 1.414l2.121-2.12a3 3 0 114.243 4.242l-.42.419a5.984 5.984 0 00-4.48 1.752 5.984 5.984 0 00-1.752 4.481l-.42.419a3 3 0 01-4.242 0zM18.5 16c-.308 0-.594-.093-.832-.251l-1.736 1.302a1.499 1.499 0 01.056.634l1.47.735a1.5 1.5 0 11-.447.894l-1.47-.734a1.5 1.5 0 11-.21-2.328l1.737-1.303A1.5 1.5 0 1118.5 16z"
      ></path>
      <path
        fill="currentColor"
        d="M9.171 13.414a1 1 0 101.415 1.414l4.242-4.242a1 1 0 00-1.414-1.414l-4.243 4.242z"
      ></path>
    </svg>
  );
}
